import React from 'react'

export default function MyEducation() {
    return (
        <div className='eduFace'>
            {/* <h1>Education</h1> */}
            <div>
                <div className='edu'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill='white' viewBox="0 -960 960 960" width="50"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z" /></svg>
                    <div>
                        <p>Full stack development course</p>
                        <p>Masai School Bengaluru</p>
                    </div>
                </div>
                <div className='edu'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill='white' viewBox="0 -960 960 960" width="50"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z" /></svg>
                    <div>
                        <p>Bachelor of Science (Math science)</p>
                        <p>Barkatullah University Bhopal</p>
                    </div>
                </div>
                <div className='edu'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill='white' viewBox="0 -960 960 960" width="50"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z" /></svg>
                    <div>
                        <p>6 Months of Internship (SDE)</p>
                        <p>Prompt Personnel Private Limited</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
